module.exports = __webpack_public_path__ + "static/media/technogym.2fd7e769.png";